// Default UX for continue/submit buttons across all purchase flows.
// v1: buttons are disabled until the form is valid (no feedback why).
// v2: buttons are always enabled; clicking an invalid form reveals inline
//     errors while a submit-handler guard blocks progression.
export const DEFAULT_PURCHASE_FLOW_TYPE = "v2";
export var CheckPurchaseEnum;
(function (CheckPurchaseEnum) {
    CheckPurchaseEnum[CheckPurchaseEnum["CheckPurchaseApproved"] = 0] = "CheckPurchaseApproved";
    CheckPurchaseEnum[CheckPurchaseEnum["CheckPurchaseNotFound"] = 10] = "CheckPurchaseNotFound";
    CheckPurchaseEnum[CheckPurchaseEnum["CheckPurchaseExpired"] = 1099] = "CheckPurchaseExpired";
})(CheckPurchaseEnum || (CheckPurchaseEnum = {}));
